export const GUI_TIN_NHAN = "GUI_TIN_NHAN";
export const GUI_TIN_NHAN_SUCCESS = "GUI_TIN_NHAN_SUCCESS";
export const GUI_TIN_NHAN_FAILURE = "GUI_TIN_NHAN_FAILURE";

export const SHOW_GUI_TIN_NHAN = "SHOW_GUI_TIN_NHAN";
